<div class="feedback-comment" [ngClass]="{embedded: embedded}">
    <div class="text" *ngIf="!task.task && !embedded">
        <div class="title my-color-blue" [innerHTML]="(for_manager ? task.title_for_manager : (for_coach ? task.title_for_coach : task.title)) | safeHtml"></div>
    </div>
    <app-journey-list-template-checkbox
            *ngIf="task.task && !embedded" class="blue"
            [task]="task"></app-journey-list-template-checkbox>

    <div *ngIf="!!task.text && !!embedded" class="text"><strong>{{for_manager ? task.text_for_manager : (for_coach ? task.text_for_coach : task.text)}}</strong></div>
    <div class="fin-input" *ngIf="!readonly">&pound;<input type="number" (input)="onChange($event)" placeholder="{{'__JOURNEY_ROI_PLACEHOLDER__' | translate}}" [(ngModel)]="value"/></div>
    <div *ngIf="readonly" class="body-text" [innerHTML]="task.details.roi.value.output"></div>
</div>
